<app-header [forceLightBackground]="true"></app-header>
<div class="admin-superset">
  <div class="admin-superset--layout">
    <app-admin-sidebar class="admin-superset--sidebar"></app-admin-sidebar>
    <div class="admin-superset--content">
      <app-page-header></app-page-header>

      <!-- ===================== OVERVIEW PAGE ===================== -->
      <ng-container *ngIf="!selectedDashboard && !requestedDashboardId; else dashboardState">

        <!-- Gallery Section -->
        <section class="dashboard-gallery">
          <div class="dashboard-gallery--header">
            
            <div class="dashboard-gallery--view-toggle">
              <button
                type="button"
                class="dashboard-gallery--view-btn"
                [class.active]="overviewView === 'card'"
                (click)="setOverviewView('card')"
                aria-label="Card view"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="3" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                  <rect x="14" y="3" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                  <rect x="3" y="14" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                  <rect x="14" y="14" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                </svg>
                <span>Card</span>
              </button>
              <button
                type="button"
                class="dashboard-gallery--view-btn"
                [class.active]="overviewView === 'table'"
                (click)="setOverviewView('table')"
                aria-label="Table view"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M3 3H21V21H3V3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M3 9H21M9 3V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>Table</span>
              </button>
            </div>
          </div>

          <div class="dashboard-gallery--grid" *ngIf="overviewView === 'card'">
            <article
              *ngFor="let dashboard of dashboards; trackBy: trackByDashboardId; let i = index"
              class="dashboard-card"
              [class.dashboard-card--featured]="i === 0"
              [style.--card-accent]="dashboard.accent"
              (click)="openDashboard(dashboard)"
            >
              <!-- Accent bar top -->
              <div class="dashboard-card--accent-bar"></div>

              <div class="dashboard-card--header">
                <div class="dashboard-card--icon-wrap">
                  <!-- chart icon -->
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2" fill="none"/>
                    <path d="M8 16V12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    <path d="M12 16V9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    <path d="M16 16V6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                </div>
                <span class="dashboard-card--category-badge">{{ dashboard.category }}</span>
              </div>

              <div class="dashboard-card--title-row">
                <h4 class="dashboard-card--title">{{ dashboard.title }}</h4>
              </div>
              <p class="dashboard-card--summary">{{ dashboard.summary }}</p>
              <div class="dashboard-card--footer">
                <span class="dashboard-card--cta">
                  View
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <polyline points="9 18 15 12 9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </div>
            </article>
          </div>

          <div class="dashboard-gallery--table-wrap" *ngIf="overviewView === 'table'">
            <table class="dashboard-gallery--table">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Dashboard</th>
                  <th>Summary</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let dashboard of dashboards; trackBy: trackByDashboardId">
                  <td>
                    <span class="dashboard-gallery--table-category">{{ dashboard.category }}</span>
                  </td>
                  <td class="dashboard-gallery--table-title">{{ dashboard.title }}</td>
                  <td class="dashboard-gallery--table-summary">{{ dashboard.summary }}</td>
                  <td>
                    <button
                      type="button"
                      class="dashboard-gallery--table-action"
                      (click)="openDashboard(dashboard)"
                    >
                      View
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

      </ng-container><!-- end overview -->

      <!-- ===================== DETAIL / EMBED VIEWS ===================== -->
      <ng-template #dashboardState>
        <ng-container *ngIf="selectedDashboard; else dashboardNotFound">

          <!-- Detail Hero -->
          <section class="detail-hero">
            <button type="button" class="detail-hero--back" (click)="goToOverview()">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <polyline points="15 18 9 12 15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              All dashboards
            </button>
            <div class="detail-hero--body">
              <div class="detail-hero--left">
                <h2 class="detail-hero--title">{{ selectedDashboard.title }}</h2>
                <p class="detail-hero--description">{{ selectedDashboard.summary }}</p>
              </div>
            </div>
          </section>

          <!-- Two-column: switcher + embed -->
          <div class="detail-layout">
            <aside class="dash-switcher">
              <span class="dash-switcher--eyebrow">Quick Switch</span>
              <p class="dash-switcher--hint">Jump directly to another dashboard</p>

              <button
                *ngFor="let dashboard of dashboards; trackBy: trackByDashboardId"
                type="button"
                class="dash-switcher--item"
                [class.dash-switcher--item-active]="isDashboardActive(dashboard.id)"
                [style.--item-accent]="dashboard.accent"
                (click)="openDashboard(dashboard)"
              >
                <span class="dash-switcher--item-dot"></span>
                <span class="dash-switcher--item-body">
                  <span class="dash-switcher--item-cat">{{ dashboard.category }}</span>
                  <span class="dash-switcher--item-title">{{ dashboard.title }}</span>
                </span>
                <svg *ngIf="isDashboardActive(dashboard.id)" class="dash-switcher--item-check" width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <polyline points="20 6 9 17 4 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </aside>

            <section class="embed-panel">
              <div class="embed-panel--loading" *ngIf="isLoading">
                <div class="embed-panel--spinner"></div>
                <span>Loading {{ selectedDashboard.title }}…</span>
              </div>
              <div #supersetMount class="admin-superset--iframe"></div>
              <p *ngIf="errorMessage" class="admin-superset--unconfigured">{{ errorMessage }}</p>
            </section>
          </div>

        </ng-container>
      </ng-template>

      <!-- Not found -->
      <ng-template #dashboardNotFound>
        <section class="not-found-state">
          <div class="not-found-state--icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
              <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="2"/>
              <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>
          <h2 class="not-found-state--title">Dashboard not found</h2>
          <p class="not-found-state--description" *ngIf="requestedDashboardId">
            No configuration entry for <code>{{ requestedDashboardId }}</code>.
          </p>
          <button type="button" class="analytics-hero--primary-btn" (click)="goToOverview()">
            Return to overview
          </button>
        </section>
      </ng-template>

    </div>
  </div>
</div>
